import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

import Demo, { DemoSliderControl } from '@/components/Demo';

import EmBoxArrow from './EmBoxArrow';
import Snippet from './Snippet';
import OutputWrapper from './OutputWrapper';

function EmDemo() {
  return (
    <Demo
      id="em-demo"
      initialValues={{
        fontSize: 16,
        marginBottom: 1.5,
      }}
      outputWrapper={OutputWrapper}
      controls={[
        <DemoSliderControl
          key="fontSize"
          id="fontSize"
          label="font-size"
          min={12}
          max={48}
          previewRenderer={(val) => `${val}px`}
        />,
        <DemoSliderControl
          key="marginBottom"
          id="marginBottom"
          label="margin-bottom"
          min={0}
          max={2}
          step={0.05}
          previewRenderer={(val) => `${val}em`}
        />,
      ]}
      controlPosition="top"
    >
      {({ fontSize, marginBottom }) => (
        <OuterWrapper>
          <Wrapper>
            <TextWrapper
              style={{ fontSize, marginBottom: `${marginBottom}em` }}
            >
              <Paragraph
                style={{
                  fontSize: `${fontSize}px`,
                }}
              >
                Some words and things.
              </Paragraph>
              <BlockWrapper>
                <EmBlock
                  style={{
                    height: fontSize * marginBottom,
                  }}
                />
                <ArrowWrapper>
                  <EmBoxArrow
                    animateTransitions={false}
                    fontSize={fontSize}
                    marginBottom={marginBottom}
                  />
                </ArrowWrapper>
              </BlockWrapper>
            </TextWrapper>
          </Wrapper>
          <Snippet
            minCodeHeight="9.5rem"
            code={generateCodeSnippet({ fontSize, marginBottom })}
          />
        </OuterWrapper>
      )}
    </Demo>
  );
}

function generateCodeSnippet({
  fontSize,
  marginBottom,
}: {
  fontSize: number;
  marginBottom: number;
}) {
  return `.some-paragraph {
  font-size: ${fontSize}px;
  margin-bottom: ${marginBottom}em;
}`;
}

const OuterWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Wrapper = styled.div`
  padding: 16px;
  margin-bottom: 1rem;

  @media ${BREAKPOINTS.smAndLarger} {
    padding: 32px;
    margin-bottom: 0;
  }
`;

const TextWrapper = styled.div`
  position: relative;
`;

const Paragraph = styled.p``;

const BlockWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  transform: translateY(100%);
`;

const EmBlock = styled.div`
  height: var(--height);
  background: #f2cea5;
`;
const ArrowWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
`;

export default EmDemo;
